avoidNetworkRequests